import React from 'react';
import { testSlackConnection } from '../../utils/slackNotification';
import { toast } from 'react-toastify';

const SlackNotificationTest = ({ style = {} }) => {
  const handleTestSlack = async () => {
    console.log('🧪 Testing Slack connection...');
    const result = await testSlackConnection();
    if (result) {
      toast.success('✅ Slack接続テスト成功！');
    } else {
      toast.error('❌ Slack接続テスト失敗');
    }
  };

  // 開発環境でのみ表示
  if (process.env.NODE_ENV !== 'development') {
    return null;
  }

  return (
    <div style={{ 
      position: 'fixed', 
      top: '10px', 
      right: '10px', 
      zIndex: 1000,
      background: '#1e293b',
      padding: '10px',
      borderRadius: '8px',
      border: '1px solid #3b82f6',
      ...style
    }}>
      <button 
        onClick={handleTestSlack}
        style={{
          background: '#3b82f6',
          color: 'white',
          border: 'none',
          padding: '8px 16px',
          borderRadius: '4px',
          cursor: 'pointer',
          fontSize: '12px'
        }}
      >
        🧪 Slack テスト
      </button>
    </div>
  );
};

export default SlackNotificationTest; 